export default __webpack_public_path__ + "static/media/icn-arrow-close-focused.26d3d991.svg";